import { render, staticRenderFns } from "./CampusList.vue?vue&type=template&id=b93107d2&"
import script from "./CampusList.vue?vue&type=script&lang=ts&"
export * from "./CampusList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports